import { ContentSubtype } from "./ContentSubtype";

export type AncillaryContentSubtype = typeof ancillaryContentSubtypes[number];

export const ancillaryContentSubtypes = [
    ContentSubtype.Advert,
    ContentSubtype.Promo,
    ContentSubtype.Safety,
    ContentSubtype.IndentWarning,
    ContentSubtype.ClientSpecific
] as const;

export const isAncillaryContentSubtype = (contentType: number): contentType is AncillaryContentSubtype =>
    ancillaryContentSubtypes.includes(contentType);

export const ensureAncillaryContentSubtype: (contentType: number) => asserts contentType is AncillaryContentSubtype = (
    contentType: AncillaryContentSubtype
) => {
    if (!ancillaryContentSubtypes.includes(contentType)) {
        throw Error(`Content type should be ancillary'`);
    }
};
